import { List } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { BiMessageAltError } from 'react-icons/bi';
import { useSelector } from 'react-redux';

import Tab from '@/components/UI/mobile/Tab';
import useService from '@/lib/hooks/useService';
import MobilePersonalNoticeDetail from '@/pages/_Mobile/MobilePersonalNoticeDetail';
import type { RootState } from '@/redux/store';
import type Message from '@/types/database/message';

import {
  getDataSource,
  getNoticeType,
  getNotifications,
  updateNoticesReadStatus,
} from './helper';
import styles from './index.module.scss';
import Notice from './Notice';

const MobileNoticeRecord: FC = () => {
  const userData = useSelector((state: RootState) => state.user);
  const userId = userData?.auth?.user?._id;
  const [messages] = useService<Message>({
    collectionName: 'message',
    query: {
      $sort: {
        createdTime: -1,
      },
      userId,
    },
  });
  const [isShowPersonalNoticeDetail, setIsShowPersonalNoticeDetail] =
    useState(false);
  const [personalNoticeDetail, setPersonalNoticeDetail] =
    useState<Message | null>(null);
  const [currentTab, setCurrentTab] = useState<0 | 1 | 2>(0);

  useEffect(() => {
    // const personalNotices = getDataSource(messages, 'personal');

    (async () => {
      await updateNoticesReadStatus();
    })();
  }, [messages]);

  const updateIsShowPersonalNoticeDetail = (isShowDetail: boolean) => {
    setIsShowPersonalNoticeDetail(isShowDetail);
  };

  const updatePersonalNoticeDetail = (
    newPersonalNoticeDetail: Message | null
  ) => {
    setPersonalNoticeDetail(newPersonalNoticeDetail);
  };

  const handleTabChange = async (activeKey: number) => {
    if (activeKey === 0) {
      setCurrentTab(activeKey);
    }
    if (activeKey === 1) {
      setCurrentTab(activeKey);
      const systemNotices = getDataSource(messages, 'system');
      await updateNoticesReadStatus(systemNotices);
    }
    if (activeKey === 2) {
      setCurrentTab(activeKey);
      const baEventNotices = getDataSource(messages, 'baEvent');
      await updateNoticesReadStatus(baEventNotices);
    }
  };

  const updateMethods = {
    updateIsShowPersonalNoticeDetail,
    updatePersonalNoticeDetail,
  };

  const notifications = getNotifications(messages, currentTab);

  return isShowPersonalNoticeDetail ? (
    <>
      <div className={styles.background} />
      <MobilePersonalNoticeDetail
        personalNoticeDetail={personalNoticeDetail}
        updateIsShowPersonalNoticeDetail={updateIsShowPersonalNoticeDetail}
        updatePersonalNoticeDetail={updatePersonalNoticeDetail}
      />
    </>
  ) : (
    <>
      <div className={styles.background} />
      <div className={styles.tabContainer}>
        <Tab
          options={['個人通知', '系統通知', 'BA通知']}
          onChange={handleTabChange}
          messages={messages}
        />
      </div>
      {notifications.length > 0 ? (
        <div className={styles.listContainer}>
          <List
            itemLayout="vertical"
            pagination={{
              pageSize: 10,
              hideOnSinglePage: true,
            }}
            dataSource={notifications}
            renderItem={(item, index) => {
              const isLastOne = index === notifications.length - 1;
              return (
                <List.Item>
                  <Notice
                    data={item}
                    isLastOne={isLastOne}
                    noticeType={getNoticeType(currentTab)}
                    updateMethods={updateMethods}
                  />
                </List.Item>
              );
            }}
          />
        </div>
      ) : (
        <div className={styles.noData}>
          <BiMessageAltError className={styles.noDataIcon} />
          <p className={styles.noDataText}>暫無訊息</p>
        </div>
      )}
    </>
  );
};

export default MobileNoticeRecord;
